import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_87: DocMigration = {
  maxSchemaVersion: "0.0.87",
  description: "Refactor foundations",
  apply(json: any) {
    migrateDoc0088FoundationSettingsRefactor(json);
    return json;
  },
};

function migrateDoc0088FoundationSettingsRefactor(json: any) {
  if (json.roomLayouts) {
    for (const layoutId in json.roomLayouts) {
      const roomLayout = json.roomLayouts[layoutId];
      if (!roomLayout.footingPatterns) {
        continue;
      }
      if (!roomLayout.footingPatterns.length) {
        delete roomLayout["footingPatterns"];
        continue;
      }
      for (const footingPattern of roomLayout.footingPatterns) {
        if (footingPattern.footingPattern.footingType === "LINEAR_FOOTING") {
          footingPattern.footingPattern.footingType = "LINEAR";
        } else if (footingPattern.footingPattern.footingType === "VOID_FOOTING") {
          footingPattern.footingPattern.footingType = "VOID";
        }
      }
    }
  }
  if (json.settings) {
    for (const settingId in json.settings) {
      const settings = json.settings[settingId];
      if (settings.type === "FOUNDATION_SETTINGS") {
        delete settings.foundationSubSystemType;
      }
      if (settings.type === "FOUNDATION_SLAB_SETTINGS") {
        if (settings.foundationSubSystemType === "STEM_WALL") {
          settings.foundationSubSystemType = "STEM_WALL_CMU";
        }
      }
      if (settings.type === "FOUNDATION_SLAB_SETTINGS_STEM") {
        settings.type = "FOUNDATION_SLAB_SETTINGS_STEM_CMU";
        settings.foundationSubSystemType = "STEM_WALL_CMU";
      }
    }
  }
  if (json.elevations) {
    for (const elevationId in json.elevations) {
      const elevation = json.elevations[elevationId];
      if (!elevation.settingsOverride?.foundationSlabStemWall) {
        continue;
      }
      const settingsId = elevation.settingsOverride.foundationSlabStemWall;
      elevation.settingsOverride.foundationSlabStemWallCMU = settingsId;
      delete elevation.settingsOverride.foundationSlabStemWall;
    }
  }
  if (json.settingsOverride?.foundationSlabStemWall) {
    const settingsId = json.settingsOverride.foundationSlabStemWall;
    json.settingsOverride.foundationSlabStemWallCMU = settingsId;
    delete json.settingsOverride.foundationSlabStemWall;
  }
  return json;
}

export default migration_0_0_87;
